import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import { CommonApiService } from './common-api.service';

export interface NarakeetCreditsInfo {
  provider?: string;
  creditSeconds?: number | null;
  creditMinutes?: number | null;
  plan?: string | null;
  identity?: string | null;
  billingId?: string | null;
  requestId?: string | null;
  checkedAt?: string | null;
  message?: string;
}

@Injectable({ providedIn: 'root' })
export class ServiceCreditsService {
  private apiUrl = `${environment.baseUrl}/serviceCredits`;

  constructor(private commonAPI: CommonApiService) {}

  getNarakeetCredits(): Observable<NarakeetCreditsInfo> {
    return this.commonAPI.postApiCall(`${this.apiUrl}/getNarakeetCredits`, { criteria: {} }) as Observable<NarakeetCreditsInfo>;
  }
}
